import React from 'react';

const services = [
  {
    title: 'Strategic Advisory',
    description:
      'Our seasoned consultants deliver high-impact strategic guidance, enabling organizations to navigate complexities and seize emerging opportunities with confidence.',
    icon: '🔍'
  },
  {
    title: 'Operational Excellence',
    description:
      'We specialize in optimizing operational efficiency through tailored solutions that enhance productivity, streamline processes, and drive performance.',
    icon: '⚙️'
  },
  {
    title: 'Technology Integration',
    description:
      'From digital transformation to advanced technology deployment, we help businesses harness the power of technology to achieve their strategic objectives.',
    icon: '💻'
  },
  {
    title: 'Change Management',
    description:
      'Our expertise in change management ensures smooth transitions, helping organizations adapt to evolving landscapes and maintain a competitive edge.',
    icon: '🔄'
  },
];

const Expertise = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-semibold text-center mb-12 text-[#13689b]">
          Our Expertise
        </h2>
        <div className="grid gap-12 lg:grid-cols-4 md:grid-cols-2 grid-cols-1">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border border-[#13689b] rounded-xl shadow-lg p-8 transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="text-center mb-6">
                <div className="text-5xl text-[#13689b] mb-4">{service.icon}</div>
                <h3 className="text-2xl font-semibold text-[#13689b]">{service.title}</h3>
              </div>
              <p className="text-lg text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
